module.exports = "<%= table %>\n";
